<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3"/>
    <div class="container">
      <div class="breadcrumb-container">
        <router-link to="/clasdiag">Clasificación de Diagnósticos</router-link>
        > {{ datoClasDiag.codigo }}
      </div>
<!--       <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
        <div class="notification-message" 
             :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
          {{ notificacion.message }}
        </div>
      </div> -->
    </div>
    <hr>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idClasDiag" class="form-label">IdClasDiag</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idClasDiag" name="idClasDiag" v-model="datoClasDiag.idClasDiag" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoClasDiag.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoClasDiag.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarClasDiag" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditClasDiag" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <!-- <th scope="col"></th> -->
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <th scope="col">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="diagnostico in datosPaginados" :key="diagnostico.idDiagnostico">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(diagnostico.idDiagnostico)" title="Editar">edit_square</i></td>
          <!-- <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(diagnostico.idDiagnostico)" title="Editar">edit_square</i></td> -->
          <td>{{diagnostico.codigo}}</td>
          <td>{{diagnostico.nombre}}</td>
          <td>{{diagnostico.estado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteClasDiag(diagnostico.idDiagnostico)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idDiagnostico" class="form-label">IdDiagnostico</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoDiagnostico.idDiagnostico" disabled>
                </div>
                <div class="col-2">
                  <label for="idClasDiag" class="form-label">IdClasDiag</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" id="idClasDiag" name="idClasDiag" v-model="datoDiagnostico.idClasDiag" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoDiagnostico.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoDiagnostico.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarDiagnostico" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditDiagnostico" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Diagnostico -->
    <DiagnosticoLOVdet @DatosDiagnostico="GetDataDiagnosticoLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import DiagnosticoLOVdet from '../../components/lovs/DiagnosticoLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, DiagnosticoLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      clasdiags : [],
      datoClasDiag : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idClasDiag: '',
// Variables master
// Variables details
      diagnosticos : [],
      datoDiagnostico : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idClasDiag = this.$route.params.p_idclasdiag
    this.abrirEditar(this.p_idClasDiag)
    this.getDiagnosticos()
    this.getDataPagina(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoClasDiag.idClasDiag === ''){
        swal("Error!", "El elemento idClasDiag no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasDiag.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasDiag.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasDiag.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarClasDiag(){
      if(this.validarForm() === 1){
        try {
          await api.post('/clasdiags', this.datoClasDiag)
          swal("Correcto!", "ClasDiag creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditClasDiag(){
      if(this.validarForm() === 1){
        try {
          await api.post('/clasdiags', this.datoClasDiag)
          swal("Correcto!", "ClasDiag creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoClasDiag={}
      this.titulo   = 'Crear Clasificación de Diagnósticos'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idClasDiag){
      this.modalWindow = true
      if(idClasDiag != null){    
           api.get('/vwclasdiags/'+idClasDiag).then(resp=>{
          this.datoClasDiag = resp.data;
           });
      }
      this.titulo   = 'Editar Clasificación de Diagnósticos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarClasDiag(){
      this.$router.push('/ClasDiag')
    },
// Procedimientos master
// Procedimientos detalle
    async getDiagnosticos() {
      const resp = await api.get('/diagnosticos')
      this.diagnosticos = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.diagnosticos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwdiagnosticos/nombre/'+this.nombreBusqueda).then(response=>{
          this.diagnosticos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.diagnosticos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwdiagnosticos/idclasdiag/'+this.p_idClasDiag).then(response=>{
      this.diagnosticos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.diagnosticos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoDiagnostico.idClasDiag === ''){
        swal("Error!", "El elemento idClasDiag no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoDiagnostico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarDiagnostico(){
      if(this.validarForm() === 1){
        try {
          this.datoDiagnostico.idClasDiag = this.datoClasDiag.idClasDiag;
          await api.post('/diagnosticos', this.datoDiagnostico)
          this.getDiagnosticos();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Diagnostico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDiagnostico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/diagnosticos', this.datoDiagnostico)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Diagnostico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoDiagnostico={}
      this.titulo   = 'Crear Clasificación de Diagnósticos'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idDiagnostico){
      this.modalWindow = true
      if(idDiagnostico != null){    
           api.get('/vwdiagnosticos/'+idDiagnostico).then(resp=>{
          this.datoDiagnostico = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Clasificación de Diagnósticos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
/*     abrirEditarDet(idDiagnostico){
      this.modalWindow = true
      if(idDiagnostico != null){
        this.$router.push('/diagnosticomd/'+idDiagnostico)
      }
    }, */
    async deleteDiagnostico (idDiagnostico) {
      try{
        await api.delete('/diagnosticos/'+idDiagnostico)
          this.getDiagnosticos()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataDiagnosticoLOVdet(data) {
      this.datoDiagnostico.idDiagnostico = data.idDiagnostico;
      this.datoDiagnostico.diagnostico = data.nombre;
    },
// Listas de valores details
  },
}
</script>
